import React from 'react';
import { HiMoon, HiSun } from 'react-icons/hi2';
import { useTranslation } from 'react-i18next';
import { useApp } from '../context/AppContext';

const DarkModeToggle = () => {
  const { t } = useTranslation();
  const { preferences, updatePreferences } = useApp();
  const isDark = preferences.darkMode || false;

  const toggleDarkMode = () => {
    const newMode = !isDark;
    updatePreferences({ darkMode: newMode });
    // AppContext useEffect will handle applying the dark class
  };

  return (
    <button
      onClick={toggleDarkMode}
      className="p-2 rounded-lg hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
      aria-label={isDark ? t('common.lightMode') : t('common.darkMode')}
      title={isDark ? t('common.lightMode') : t('common.darkMode')}
    >
      {isDark ? (
        <HiSun className="h-5 w-5 text-yellow-500" />
      ) : (
        <HiMoon className="h-5 w-5 text-gray-600 dark:text-gray-400" />
      )}
    </button>
  );
};

export default DarkModeToggle;
